import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AuthLayout from "./AuthLayout";
import { GoogleButton, Divider } from "./Login";
import { api, apiError, nextFrom } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, ErrorState } from "@/components/common";

export default function Register() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ name: "", email: new URLSearchParams(loc.search).get("email") || "", password: "", company: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) return setErr("Password must be at least 8 characters.");
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      nav(nextFrom(loc.search) || "/command-centre", { replace: true });
    } catch (e2) { setErr(apiError(e2)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Create your account" subtitle="Set up a workspace for your company or brand.">
      <GoogleButton />
      <Divider />
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Full name"><input data-testid="register-name-input" required className="cq-input" value={form.name} onChange={set("name")} /></Field>
        <Field label="Email"><input data-testid="register-email-input" type="email" required className="cq-input" value={form.email} onChange={set("email")} /></Field>
        <Field label="Password" hint="At least 8 characters"><input data-testid="register-password-input" type="password" required className="cq-input" value={form.password} onChange={set("password")} /></Field>
        <Field label="Company / workspace name (optional)"><input data-testid="register-company-input" className="cq-input" value={form.company} onChange={set("company")} /></Field>
        {err && <ErrorState message={err} testId="register-error" />}
        <button data-testid="register-submit-button" disabled={busy} className="cq-btn cq-btn-primary w-full !py-2.5">
          {busy && <Loader2 size={14} className="animate-spin" />} Create account
        </button>
      </form>
      <p className="mt-6 text-sm text-[#AAB6CC]">Already have an account? <Link data-testid="login-link" to={`/login${loc.search}`} className="text-[#22E6F2] hover:underline">Sign in</Link></p>
    </AuthLayout>
  );
}
